module.exports = __webpack_public_path__ + "media/tr_tr_s6_Zeynep.71c8e18c.mp3";